/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

export default (fields) => {
  return new Promise(async (resolve, reject) => {
    var count = 1;
    var numberRegex = new RegExp("[0-9]", "g");
    var decimalNumberRegexp = /^-?\d+(\.\d{1,2})?$/;
    for (var i = 0; i < fields.length; i++) {
      if (
        fields[i].required &&
        (!fields[i].value ||
          (Array.isArray(fields[i].value) && fields[i].value.length === 0))
      ) {
        resolve('"' + fields[i].name + '" is required.');
        break;
      }
      if (fields[i].type === "integer" || fields[i].type === "decimal") {
        if (fields[i].value) {
          var result = decimalNumberRegexp.test(fields[i].value);
          if (!result) {
            resolve('"' + fields[i].name + '" is invalid.');
            break;
          }
        }
      }
      if (fields[i].params) {
        if (fields[i].params.minLength) {
          var length = fields[i].value.length;
          if (length < fields[i].params.minLength) {
            resolve(
              '"' +
                fields[i].name +
                '" should contain minimum ' +
                fields[i].params.minLength +
                " characters.",
            );
            break;
          }
        }
        if (fields[i].params.maxLength) {
          if (length > fields[i].params.maxLength) {
            resolve(
              '"' +
                fields[i].name +
                '" should contain maximum ' +
                fields[i].params.maxLength +
                " characters.",
            );
            break;
          }
        }
        if (fields[i].params.mask) {
        }
        if (fields[i].params.regexPattern) {
          if (fields[i].value) {
            var regExpNew = new RegExp(fields[i].params.regexPattern);
            var result = regExpNew.test(fields[i].value);
            if (!result) {
              resolve('"' + fields[i].name + '" format is invalid.');
              break;
            }
          }
        }
      }
      if (count === fields.length) {
        resolve("valid");
      }
      count++;
    }
  });
};
